const s = {
  name: "Hands00111",
  dimensions: { width: 26, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 40" style="enable-background:new 0 0 26 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M6,4v8.5C5.4,12.2,4.7,12,4,12c-2.2,0-4,1.8-4,4v11c0,7.2,5.8,13,13,13s13-5.8,13-13V10.4C26,8.1,24.3,6,22,6
			c-0.7,0-1.4,0.2-2,0.6V6c0-2.2-1.8-4-4-4c-0.8,0-1.6,0.2-2.2,0.7C13.2,1.1,11.7,0,10,0C7.8,0,6,1.8,6,4z M10,2c1.1,0,2,0.9,2,2
			v15.5c-0.6-0.3-1.3-0.5-2-0.5H8V4C8,2.9,8.9,2,10,2z M4,14c1.1,0,2,0.9,2,2v3H4c-0.7,0-1.4,0.2-2,0.5V16C2,14.9,2.9,14,4,14z
			 M14,21V6c0-1.1,0.9-2,2-2s2,0.9,2,2v15H14z M14,23h8v-2h-2V10.4C20,9,21,8,22,8s2,1,2,2.4V27c0,6.1-4.9,11-11,11
			C6.9,38,2,33.1,2,27v-4c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2s-0.9,2-2,2H6v2h4C12.2,27,14,25.2,14,23z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Hands00111
};
